import { Outlet, useOutlet } from 'react-router-dom';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import InfoBar from 'components/InfoBar/InfoBar';
import moveStep from 'hooks/moveStep';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import { workflowActions, workflowSelectors } from 'state/workflow';
import { authSelectors } from 'state/auth';
import { useEffect } from 'react';
import { ConfigurableHyperLinkSelector } from 'state/hyperlink/hyperlink.selectors';
import { Col, Container } from 'react-bootstrap';
import WorkflowNavigationButton from 'components/Buttons/WorkflowNavigationButton/WorkflowNavigationButton';

interface IDPFormProps {
  identifier: string;
}
const IDPForm = ({ identifier }: IDPFormProps) => {
  const outlet = useOutlet();
  const user = useAppSelector(authSelectors.userSelector);
  const hyperlinks = useAppSelector(ConfigurableHyperLinkSelector);
  const dispatch = useAppDispatch();

  const { onNextClick } = moveStep();
  const form = useAppSelector(workflowSelectors.workflowForm);

  const handleClick = () => {
    dispatch(workflowActions.setLoading(true));
    onNextClick(form.uuid, {});
  };

  useEffect(() => {
    dispatch(workflowActions.setLoading(false));
  }, []);

  if (!identifier) {
    return null;
  }

  if (outlet) {
    return <Outlet />;
  }

  return (
    <Col>
      {user && (
        <Container className="bg-light-gray border p-3">
          {user && <h5 className="m-0 fw-bold">{`Hello Dr. ${user.name}`}</h5>}
        </Container>
      )}
      <div>
        <div className="mt-3">
          Complete the identity proofing process provided by DrFirst. The process requires
          submitting identification documents, such as a driver's license, passport, or other
          government-issued ID, along with a photo of yourself for verification.
          <br />
          <br />
          If it has been more than 24 hours since you submitted your registration and you have not
          received the invitation, use the link below to resend the invite.
        </div>

        <WorkflowNavigationButton
          id="resend-idp-invite-button"
          text="Resend IDP Invite"
          variant="danger"
          icon={faEnvelopeOpenText}
          iconLeft
          iconSize="lg"
          onClick={handleClick}
          className="mt-3 mb-3"
        />
      </div>
      <InfoBar border>
        If you have not received the Identity Proofing email or need additional assistance,{' '}
        <a
          id="chat-with-us-anchor-IDP-form"
          href={hyperlinks['support_chat_url']}
          target="_blank"
          className="text-purple"
        >
          chat with us
        </a>{' '}
        or contact support at (855) 863-1355. Please have your NPI and email address ready.
      </InfoBar>
    </Col>
  );
};

export default IDPForm;
